.tag{text-indent:0;padding-left:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;font-size:14px;font-weight:400}:host.selected-shape-item .tag{color:#5a42d0;font-weight:500}
/*# sourceMappingURL=objectless-shape-label.component.css.map */
